import { render, staticRenderFns } from "./FooterIndex.vue?vue&type=template&id=13365514"
import script from "./FooterIndex.vue?vue&type=script&lang=js"
export * from "./FooterIndex.vue?vue&type=script&lang=js"
import style0 from "./FooterIndex.vue?vue&type=style&index=0&id=13365514&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports